import { motion } from 'framer-motion';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-secondary text-white">
      {/* Main Footer Content */}
      <div className="max-w-[1200px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img
              src="https://static.wixstatic.com/media/35bb17_1270289f609d49aa946b7334865cb8f0~mv2.png/v1/fill/w_253,h_127,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/daa0609c-62be-4f5e-90dc-2240ea7c4e77.png"
              alt="KC PDR Logo"
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="font-inter text-white/80 text-sm leading-relaxed mb-4">
              Over 30 years of experience providing professional paintless dent repair services in Kansas City metro area.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/KCPDR/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-primary rounded-full transition-all duration-300 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://youtu.be/0FTXsZPhLyw?si=bY4LHEERbQr8lj2l"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-primary rounded-full transition-all duration-300 cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-montserrat font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="font-inter text-white/80 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="font-inter text-white/80 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('projects')}
                  className="font-inter text-white/80 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Our Work
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="font-inter text-white/80 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-montserrat font-bold text-lg mb-4">Services</h3>
            <ul className="space-y-2">
              <li className="font-inter text-white/80 text-sm">Hail Damage Repair</li>
              <li className="font-inter text-white/80 text-sm">Dent Repair</li>
              <li className="font-inter text-white/80 text-sm">Rental Car Repair</li>
              <li className="font-inter text-white/80 text-sm">Fleet Vehicle Repair</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-montserrat font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-primary mt-1"></i>
                <div>
                  <a
                    href="tel:660-342-6164"
                    className="font-inter text-white/80 hover:text-white transition-colors text-sm cursor-pointer"
                  >
                    (660) 342-6164
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-primary mt-1"></i>
                <div>
                  <a
                    href="mailto:info@kcpdr.com"
                    className="font-inter text-white/80 hover:text-white transition-colors text-sm cursor-pointer"
                  >
                    info@kcpdr.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary mt-1"></i>
                <div>
                  <p className="font-inter text-white/80 text-sm">
                    9240 Northwest 63rd Street<br />
                    Parkville, MO 64152
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-primary mt-1"></i>
                <div>
                  <p className="font-inter text-white/80 text-sm">
                    Mon–Fri: 8AM–5PM
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-[1200px] mx-auto px-6 py-6">
          <div className="flex items-center justify-center">
            <p className="font-inter text-white/60 text-sm text-center">
              © 2025 KC PDR. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
